var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":_vm.externalColor ?? _setup.color,"height":"40","dark":""}},[_c('v-toolbar-title',[_vm._v(" "+_vm._s(_vm.externalTitle ?? _vm.$t(_setup.title))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }